import {DeviceParamLirisV3TriggerData} from "./device-param-liris-v3-trigger-data";
import {DeviceParamLirisV3Thresold} from "./device-param-liris-v3-thresold";
import {DeviceParamLirisV3Filter} from "./device-param-liris-v3-filter";

export class DeviceParamLirisV3Trigger {

    public amplitude: DeviceParamLirisV3TriggerData[] = [];
    public threshold: DeviceParamLirisV3Thresold = new DeviceParamLirisV3Thresold();
    public filter: DeviceParamLirisV3Filter[] = [];
}
